// Repack a DVR into the videoRecorder shape Dashcam/bulk_screenshots expect.
// `deviceHost` overrides `dvr_ipv4` (pass DDNS/WAN for cloud); `inferenceHostname`
// feeds the Dashcam VPN-tunnel lookup.
export default function installationToVideoRecorderShape({
  dvr,
  typeName,
  inferenceHostname,
  channelNumbers,
  subType,
  deviceHost,
}) {
  const channels =
    Array.isArray(channelNumbers) && channelNumbers.length
      ? channelNumbers.map((n) => ({
          channel_number: n,
          protocol: "tcp",
          inference_machine_data: inferenceHostname ? { hostname: inferenceHostname } : null,
        }))
      : [{ inference_machine_data: inferenceHostname ? { hostname: inferenceHostname } : null }];

  return {
    device_ip: deviceHost ?? dvr?.dvr_ipv4 ?? null,
    device_rtsp_port: dvr?.dvr_rtsp_port ?? null,
    device_rtsp_port_redirected: dvr?.dvr_external_rtsp_port ?? null,
    device_api_port: dvr?.dvr_http_port ?? null,
    device_api_port_redirected: dvr?.dvr_external_http_port ?? null,
    username: dvr?.dvr_login ?? null,
    password: dvr?.dvr_password ?? null,
    rtsp_url_suffix: dvr?.rtsp_url_suffix ?? null,
    type: typeName ? { name: typeName } : null,
    video_recorder_type_name: typeName ?? null,
    sub_type: subType ?? "main",
    channels,
  };
}
